<template>
  <div
    class="chatbot-btn tw-flex tw-flex-col tw-w-min tw-whitespace-nowrap tw-max-w-[15rem] tw-gap-2"
  >
    <button
      v-for="option in options"
      :key="JSON.stringify(option)"
      @click="onClick(option)"
      class="message tw-p-2 tw-rounded-full tw-bg-slate-100 tw-text-slate-700 tw-shadow tw-drop-shadow-md hover:tw-bg-slate-200"
    >
      {{ option.Title }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ChatBotButton",
  props: ["message"],
  computed: {
    options() {
      return this.message.Options;
    },
  },
  methods: {
    onClick(selected) {
      //   console.log(selected);
      this.$emit("on-click-message", selected);
    },
  },
};
</script>

<style>

</style>
